// extracted by mini-css-extract-plugin
module.exports = {"ageRestrictionMessage":"AgeRestrictionMessage_ageRestrictionMessage__6toL1","message":"AgeRestrictionMessage_message__B0luO"};